"use client";
import "@/components/notification/globalBanner.scss";
import Image from "next/image";
import Close from "@/public/svg/common/header/close_white.svg";
import Button from "@/components/button/Button";
import { useBanner } from "./GlobalBannerContext";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

const GlobalBanner = ({ content, color }: any) => {
    const { bannerVisible, closeBanner, isMobile, setIsMobile, setBannerVisible, toggleBanner }: any = useBanner();
    const pathname = usePathname();

    useEffect(() => {
    const hiddenRoutes = ['/japan-group-tour', '/thailand-tour'];
    const homeRoute = '/';

    if (hiddenRoutes.includes(pathname)) {
        setBannerVisible(false);
        return;
    }

    if (window.innerWidth > 500) {
        setBannerVisible(true);
        setIsMobile(false);
    } else {
        setIsMobile(true);
    }

    const handleScroll = () => {
        if (window.innerWidth < 500 && pathname !== homeRoute) {
            if (window.scrollY > 6000 || window.scrollY < 1000) {
                setBannerVisible(false);
            } else {
                setBannerVisible(true);
            }
        } else if (window.innerWidth < 500 && pathname === homeRoute) {
            setBannerVisible(true);
        }
    };

    const handleResize = () => {
        if (window.innerWidth > 500) {
            setBannerVisible(true);
            setIsMobile(false);
        } else {
            setIsMobile(true);
            if (pathname === homeRoute) {
                setBannerVisible(true);
            }
        }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
    };
}, [pathname, setBannerVisible, setIsMobile]);

    return (
        <>
            {closeBanner && bannerVisible && (
                <div className="global_form sm:w-100 mx-auto ">
                    <div
                        style={{ backgroundColor: `${color}` }}
                        className={`lg:flex flex flex-col-reverse lg:flex-row px-2 sm-notification-banner_image justify-center sm:text-center sticky-info-bar  lg:bg-notification-banner_image bg-cover items-center  py-5 lg:mx-6 mt-5 bg-orange-400 rounded-xl relative`}
                    >
                        <div className="flex lg:flex-row  flex-col items-center">
                            <span className="text-lg lg:text-xl font-bold text-white block lg:inline z-10">
                               Join our all-inclusive Japan Group Tour – Only 15 Seats Left
                            </span>

                            <Button
                                className="flex items-center sm-text-center z-20 sm-mt-3 lg:mx-10 relative"
                                variant="green"
                            >
                                <a
                                    href="https://wa.link/2vsy9d"
                                    className="flex items-center justify-center "
                                    target="_blank"
                                >
                                    <span>👉 Book Now & Save Your Seat </span>
                                </a>
                            </Button>
                        </div>

                        <div className="mobile-header flex self-end justify-between lg:self-center lg:absolute right-5 inset-2/4 relative inset-x-0">
                            <figure
                                className="hamburger-close ml-auto "
                                onClick={toggleBanner}
                            >
                                <Image
                                    loading="lazy"
                                    src={Close}
                                    alt="Close"
                                    width={36}
                                    height={36}
                                />
                            </figure>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GlobalBanner;